import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
export class Weapon {
  get descriptor() {
    return Weapon.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._parent = null;
    this._hasFamily = false;
    this._family = null;
    this._hasEffect = false;
    this._effectName = null;
    this._hasCriticalChance = false;
    this._criticalChance = null;
    this._hasCriticalEffect = false;
    this._criticalEffect = null;
    this._hasIndependentTargetAcquisition = false;
    this._independentTargetAcquisition = null;
    this._hasIndependentPreAndBackSwing = false;
    this._independentPreAndBackSwing = null;
    this._hasCanFireWhileMoving = false;
    this._canFireWhileMoving = null;
    this._hasChanneled = false;
    this._channeled = null;
    this._hasForceCastFollowthrough = false;
    this._forceCastFollowthrough = null;
    this._hasNoTurnOutsideOfArc = false;
    this._noTurnOutsideOfArc = null;
    this._validators = [];
    this._hasStats = false;
    this._stats = null;
    this._hasDistanceCheckMode = false;
    this._distanceCheckMode = null;
    this._hasDistanceExtendMode = false;
    this._distanceExtendMode = null;
    this._hasTargetFilter = false;
    this._targetFilter = null;
    this._hasDisabled = false;
    this._disabled = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._hasFamily) return false;
    if (this._hasEffect) return false;
    if (this._hasCriticalChance) return false;
    if (this._hasCriticalEffect) return false;
    if (this._hasIndependentTargetAcquisition) return false;
    if (this._hasIndependentPreAndBackSwing) return false;
    if (this._hasCanFireWhileMoving) return false;
    if (this._hasChanneled) return false;
    if (this._hasForceCastFollowthrough) return false;
    if (this._hasNoTurnOutsideOfArc) return false;
    if (this._validators.length > 0) return false;
    if (this._hasStats && !this._stats.isEmpty()) return false;
    if (this._hasDistanceCheckMode) return false;
    if (this._hasDistanceExtendMode) return false;
    if (this._hasTargetFilter && !this._targetFilter.isEmpty()) return false;
    if (this._hasDisabled) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Weapon) {
      return value;
    }
    return Weapon.fromJson(value);
  }
  static fromJson(json) {
    const result = new Weapon();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.parent != null) {
      result._hasParent = true;
      result._parent = JsonToString.fromJson(json.parent);
    }
    if (json.family != null) {
      result._hasFamily = true;
      result._family = JsonToString.fromJson(json.family);
    }
    if (json.effectName != null) {
      result._hasEffect = true;
      result._effectName = JsonToString.fromJson(json.effectName);
    }
    if (json.criticalChance != null) {
      result._hasCriticalChance = true;
      result._criticalChance = JsonToDouble.fromJson(json.criticalChance);
    }
    if (json.criticalEffect != null) {
      result._hasCriticalEffect = true;
      result._criticalEffect = JsonToString.fromJson(json.criticalEffect);
    }
    if (json.independentTargetAcquisition != null) {
      result._hasIndependentTargetAcquisition = true;
      result._independentTargetAcquisition = JsonToBoolean.fromJson(json.independentTargetAcquisition);
    }
    if (json.independentPreAndBackSwing != null) {
      result._hasIndependentPreAndBackSwing = true;
      result._independentPreAndBackSwing = JsonToBoolean.fromJson(json.independentPreAndBackSwing);
    }
    if (json.canFireWhileMoving != null) {
      result._hasCanFireWhileMoving = true;
      result._canFireWhileMoving = JsonToBoolean.fromJson(json.canFireWhileMoving);
    }
    if (json.channeled != null) {
      result._hasChanneled = true;
      result._channeled = JsonToBoolean.fromJson(json.channeled);
    }
    if (json.forceCastFollowthrough != null) {
      result._hasForceCastFollowthrough = true;
      result._forceCastFollowthrough = JsonToBoolean.fromJson(json.forceCastFollowthrough);
    }
    if (json.noTurnOutsideOfArc != null) {
      result._hasNoTurnOutsideOfArc = true;
      result._noTurnOutsideOfArc = JsonToBoolean.fromJson(json.noTurnOutsideOfArc);
    }
    result._validators = JsonToList(json.validators, JsonToString);
    if (json.stats != null) {
      result._hasStats = true;
      result._stats = WeaponStats.fromJson(json.stats);
    }
    if (json.distanceCheckMode != null) {
      result._hasDistanceCheckMode = true;
      result._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromJson(json.distanceCheckMode);
    }
    if (json.distanceExtendMode != null) {
      result._hasDistanceExtendMode = true;
      result._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromJson(json.distanceExtendMode);
    }
    if (json.targetFilter != null) {
      result._hasTargetFilter = true;
      result._targetFilter = dcei_engine_effect_proto.SearchFilter.fromJson(json.targetFilter);
    }
    if (json.disabled != null) {
      result._hasDisabled = true;
      result._disabled = JsonToBoolean.fromJson(json.disabled);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.parent = JsonToString.toJson(this._parent);
    }
    if (this._hasFamily) {
      result.family = JsonToString.toJson(this._family);
    }
    if (this._hasEffect) {
      result.effectName = JsonToString.toJson(this._effectName);
    }
    if (this._hasCriticalChance) {
      result.criticalChance = JsonToDouble.toJson(this._criticalChance);
    }
    if (this._hasCriticalEffect) {
      result.criticalEffect = JsonToString.toJson(this._criticalEffect);
    }
    if (this._hasIndependentTargetAcquisition) {
      result.independentTargetAcquisition = JsonToBoolean.toJson(this._independentTargetAcquisition);
    }
    if (this._hasIndependentPreAndBackSwing) {
      result.independentPreAndBackSwing = JsonToBoolean.toJson(this._independentPreAndBackSwing);
    }
    if (this._hasCanFireWhileMoving) {
      result.canFireWhileMoving = JsonToBoolean.toJson(this._canFireWhileMoving);
    }
    if (this._hasChanneled) {
      result.channeled = JsonToBoolean.toJson(this._channeled);
    }
    if (this._hasForceCastFollowthrough) {
      result.forceCastFollowthrough = JsonToBoolean.toJson(this._forceCastFollowthrough);
    }
    if (this._hasNoTurnOutsideOfArc) {
      result.noTurnOutsideOfArc = JsonToBoolean.toJson(this._noTurnOutsideOfArc);
    }
    if (this._validators.length > 0) {
      result.validators = ArrayToJson(this._validators, JsonToString);
    }
    if (this._hasStats && !this._stats.isEmpty()) {
      result.stats = WeaponStats.toJson(this._stats);
    }
    if (this._hasDistanceCheckMode) {
      result.distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.toJson(this._distanceCheckMode);
    }
    if (this._hasDistanceExtendMode) {
      result.distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.toJson(this._distanceExtendMode);
    }
    if (this._hasTargetFilter && !this._targetFilter.isEmpty()) {
      result.targetFilter = dcei_engine_effect_proto.SearchFilter.toJson(this._targetFilter);
    }
    if (this._hasDisabled) {
      result.disabled = JsonToBoolean.toJson(this._disabled);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get parent() {
    return this._hasParent ? this._parent : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['parent']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['parent'])};
  }
  /**
   * @returns {string}
   */
  get family() {
    return this._hasFamily ? this._family : JsonToString.default;
  }
  get hasFamily() {
    return this._hasFamily;
  }
  setFamily(path, value) {
    return {type: 'SET', path: path.concat(['family']), value};
  }
  deleteFamily(path) {
    return {type: 'DELETE', path: path.concat(['family'])};
  }
  /**
   * @returns {string}
   */
  get effectName() {
    return this._hasEffect ? this._effectName : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effectName']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effectName'])};
  }
  /**
   * @returns {number}
   */
  get criticalChance() {
    return this._hasCriticalChance ? this._criticalChance : JsonToDouble.default;
  }
  get hasCriticalChance() {
    return this._hasCriticalChance;
  }
  setCriticalChance(path, value) {
    return {type: 'SET', path: path.concat(['criticalChance']), value};
  }
  deleteCriticalChance(path) {
    return {type: 'DELETE', path: path.concat(['criticalChance'])};
  }
  /**
   * @returns {string}
   */
  get criticalEffect() {
    return this._hasCriticalEffect ? this._criticalEffect : JsonToString.default;
  }
  get hasCriticalEffect() {
    return this._hasCriticalEffect;
  }
  setCriticalEffect(path, value) {
    return {type: 'SET', path: path.concat(['criticalEffect']), value};
  }
  deleteCriticalEffect(path) {
    return {type: 'DELETE', path: path.concat(['criticalEffect'])};
  }
  /**
   * @returns {boolean}
   */
  get independentTargetAcquisition() {
    return this._hasIndependentTargetAcquisition ? this._independentTargetAcquisition : JsonToBoolean.default;
  }
  get hasIndependentTargetAcquisition() {
    return this._hasIndependentTargetAcquisition;
  }
  setIndependentTargetAcquisition(path, value) {
    return {type: 'SET', path: path.concat(['independentTargetAcquisition']), value};
  }
  deleteIndependentTargetAcquisition(path) {
    return {type: 'DELETE', path: path.concat(['independentTargetAcquisition'])};
  }
  /**
   * @returns {boolean}
   */
  get independentPreAndBackSwing() {
    return this._hasIndependentPreAndBackSwing ? this._independentPreAndBackSwing : JsonToBoolean.default;
  }
  get hasIndependentPreAndBackSwing() {
    return this._hasIndependentPreAndBackSwing;
  }
  setIndependentPreAndBackSwing(path, value) {
    return {type: 'SET', path: path.concat(['independentPreAndBackSwing']), value};
  }
  deleteIndependentPreAndBackSwing(path) {
    return {type: 'DELETE', path: path.concat(['independentPreAndBackSwing'])};
  }
  /**
   * @returns {boolean}
   */
  get canFireWhileMoving() {
    return this._hasCanFireWhileMoving ? this._canFireWhileMoving : JsonToBoolean.default;
  }
  get hasCanFireWhileMoving() {
    return this._hasCanFireWhileMoving;
  }
  setCanFireWhileMoving(path, value) {
    return {type: 'SET', path: path.concat(['canFireWhileMoving']), value};
  }
  deleteCanFireWhileMoving(path) {
    return {type: 'DELETE', path: path.concat(['canFireWhileMoving'])};
  }
  /**
   * @returns {boolean}
   */
  get channeled() {
    return this._hasChanneled ? this._channeled : JsonToBoolean.default;
  }
  get hasChanneled() {
    return this._hasChanneled;
  }
  setChanneled(path, value) {
    return {type: 'SET', path: path.concat(['channeled']), value};
  }
  deleteChanneled(path) {
    return {type: 'DELETE', path: path.concat(['channeled'])};
  }
  /**
   * @returns {boolean}
   */
  get forceCastFollowthrough() {
    return this._hasForceCastFollowthrough ? this._forceCastFollowthrough : JsonToBoolean.default;
  }
  get hasForceCastFollowthrough() {
    return this._hasForceCastFollowthrough;
  }
  setForceCastFollowthrough(path, value) {
    return {type: 'SET', path: path.concat(['forceCastFollowthrough']), value};
  }
  deleteForceCastFollowthrough(path) {
    return {type: 'DELETE', path: path.concat(['forceCastFollowthrough'])};
  }
  /**
   * @returns {boolean}
   */
  get noTurnOutsideOfArc() {
    return this._hasNoTurnOutsideOfArc ? this._noTurnOutsideOfArc : JsonToBoolean.default;
  }
  get hasNoTurnOutsideOfArc() {
    return this._hasNoTurnOutsideOfArc;
  }
  setNoTurnOutsideOfArc(path, value) {
    return {type: 'SET', path: path.concat(['noTurnOutsideOfArc']), value};
  }
  deleteNoTurnOutsideOfArc(path) {
    return {type: 'DELETE', path: path.concat(['noTurnOutsideOfArc'])};
  }
  /**
   * @returns {string[]}
   */
  get validators() {
    return this._validators;
  }
  addValidators(path, value) {
    return {type: 'ADD', path: path.concat(['validators']), value};
  }
  setValidators(path, value) {
    return {type: 'SET', path: path.concat(['validators']), value: ArrayToJson(value, JsonToString)};
  }
  setValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['validators', key]), value};
  }
  deleteValidators(path) {
    return {type: 'DELETE', path: path.concat(['validators'])};
  }
  deleteValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['validators', key])};
  }
  /**
   * @returns {WeaponStats}
   */
  get stats() {
    return this._hasStats ? this._stats : WeaponStats.default;
  }
  get hasStats() {
    return this._hasStats;
  }
  setStats(path, value) {
    return {type: 'SET', path: path.concat(['stats']), value: value.toJson()};
  }
  deleteStats(path) {
    return {type: 'DELETE', path: path.concat(['stats'])};
  }
  /**
   * @returns {number}
   */
  get distanceCheckMode() {
    return this._hasDistanceCheckMode ? this._distanceCheckMode : dcei_engine_effect_proto.DistanceCheckModes.default;
  }
  get hasDistanceCheckMode() {
    return this._hasDistanceCheckMode;
  }
  setDistanceCheckMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceCheckMode']), value};
  }
  deleteDistanceCheckMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceCheckMode'])};
  }
  /**
   * @returns {number}
   */
  get distanceExtendMode() {
    return this._hasDistanceExtendMode ? this._distanceExtendMode : dcei_engine_effect_proto.DistanceExtendModes.default;
  }
  get hasDistanceExtendMode() {
    return this._hasDistanceExtendMode;
  }
  setDistanceExtendMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceExtendMode']), value};
  }
  deleteDistanceExtendMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceExtendMode'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.SearchFilter}
   */
  get targetFilter() {
    return this._hasTargetFilter ? this._targetFilter : dcei_engine_effect_proto.SearchFilter.default;
  }
  get hasTargetFilter() {
    return this._hasTargetFilter;
  }
  setTargetFilter(path, value) {
    return {type: 'SET', path: path.concat(['targetFilter']), value: value.toJson()};
  }
  deleteTargetFilter(path) {
    return {type: 'DELETE', path: path.concat(['targetFilter'])};
  }
  /**
   * @returns {boolean}
   */
  get disabled() {
    return this._hasDisabled ? this._disabled : JsonToBoolean.default;
  }
  get hasDisabled() {
    return this._hasDisabled;
  }
  setDisabled(path, value) {
    return {type: 'SET', path: path.concat(['disabled']), value};
  }
  deleteDisabled(path) {
    return {type: 'DELETE', path: path.concat(['disabled'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasParent = true;
              copy._parent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasParent = false;
              copy._parent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "family": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasFamily = true;
              copy._family = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFamily) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasFamily = false;
              copy._family = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effectName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasEffect = true;
              copy._effectName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasEffect = false;
              copy._effectName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "criticalChance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasCriticalChance = true;
              copy._criticalChance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalChance) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasCriticalChance = false;
              copy._criticalChance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "criticalEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasCriticalEffect = true;
              copy._criticalEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalEffect) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasCriticalEffect = false;
              copy._criticalEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "independentTargetAcquisition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasIndependentTargetAcquisition = true;
              copy._independentTargetAcquisition = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndependentTargetAcquisition) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasIndependentTargetAcquisition = false;
              copy._independentTargetAcquisition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "independentPreAndBackSwing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasIndependentPreAndBackSwing = true;
              copy._independentPreAndBackSwing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndependentPreAndBackSwing) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasIndependentPreAndBackSwing = false;
              copy._independentPreAndBackSwing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "canFireWhileMoving": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasCanFireWhileMoving = true;
              copy._canFireWhileMoving = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCanFireWhileMoving) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasCanFireWhileMoving = false;
              copy._canFireWhileMoving = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "channeled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasChanneled = true;
              copy._channeled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChanneled) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasChanneled = false;
              copy._channeled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forceCastFollowthrough": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasForceCastFollowthrough = true;
              copy._forceCastFollowthrough = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForceCastFollowthrough) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasForceCastFollowthrough = false;
              copy._forceCastFollowthrough = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "noTurnOutsideOfArc": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasNoTurnOutsideOfArc = true;
              copy._noTurnOutsideOfArc = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNoTurnOutsideOfArc) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasNoTurnOutsideOfArc = false;
              copy._noTurnOutsideOfArc = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "validators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._validators = [];        for (let i of value) {
                copy._validators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Weapon(this);
              copy._validators = copy._validators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._validators.length === 0) {
                return this;
              }
              const copy = new Weapon(this);
              copy._validators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._validators = copy._validators.slice();
              copy._validators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Weapon(this);
              copy._validators = copy._validators.slice(0, path[1]).concat(copy._validators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          const oldValue = this._validators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Weapon(this);
          copy._validators = copy._validators.slice();
          copy._validators[key] = newValue;
          return copy;
        }
      }
      case "stats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasStats = true;
              copy._stats = WeaponStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStats) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasStats = false;
              copy._stats = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStats) {
            const copy = new Weapon(this);
            copy._hasStats = true;
            copy._stats = WeaponStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._stats.apply(type, path.slice(1), value);
          if (newValue === this._stats) {
            return this;
          }
          const copy = new Weapon(this);
          copy._stats = copy._stats.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "distanceCheckMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasDistanceCheckMode = true;
              copy._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceCheckMode) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasDistanceCheckMode = false;
              copy._distanceCheckMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceExtendMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasDistanceExtendMode = true;
              copy._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceExtendMode) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasDistanceExtendMode = false;
              copy._distanceExtendMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasTargetFilter = true;
              copy._targetFilter = dcei_engine_effect_proto.SearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetFilter) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasTargetFilter = false;
              copy._targetFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetFilter) {
            const copy = new Weapon(this);
            copy._hasTargetFilter = true;
            copy._targetFilter = dcei_engine_effect_proto.SearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetFilter.apply(type, path.slice(1), value);
          if (newValue === this._targetFilter) {
            return this;
          }
          const copy = new Weapon(this);
          copy._targetFilter = copy._targetFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "disabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Weapon(this);
              copy._hasDisabled = true;
              copy._disabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisabled) {
                return this;
              }
              const copy = new Weapon(this);
              copy._hasDisabled = false;
              copy._disabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Weapon} other
   * @returns {Weapon}
   */
  merge(other) {
    const copy = new Weapon(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._parent = other._parent;
    }
    if (other._hasFamily) {
      copy._hasFamily = true;
      copy._family = other._family;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effectName = other._effectName;
    }
    if (other._hasCriticalChance) {
      copy._hasCriticalChance = true;
      copy._criticalChance = other._criticalChance;
    }
    if (other._hasCriticalEffect) {
      copy._hasCriticalEffect = true;
      copy._criticalEffect = other._criticalEffect;
    }
    if (other._hasIndependentTargetAcquisition) {
      copy._hasIndependentTargetAcquisition = true;
      copy._independentTargetAcquisition = other._independentTargetAcquisition;
    }
    if (other._hasIndependentPreAndBackSwing) {
      copy._hasIndependentPreAndBackSwing = true;
      copy._independentPreAndBackSwing = other._independentPreAndBackSwing;
    }
    if (other._hasCanFireWhileMoving) {
      copy._hasCanFireWhileMoving = true;
      copy._canFireWhileMoving = other._canFireWhileMoving;
    }
    if (other._hasChanneled) {
      copy._hasChanneled = true;
      copy._channeled = other._channeled;
    }
    if (other._hasForceCastFollowthrough) {
      copy._hasForceCastFollowthrough = true;
      copy._forceCastFollowthrough = other._forceCastFollowthrough;
    }
    if (other._hasNoTurnOutsideOfArc) {
      copy._hasNoTurnOutsideOfArc = true;
      copy._noTurnOutsideOfArc = other._noTurnOutsideOfArc;
    }
    copy._validators = this._validators.concat(other._validators);
    if (other._hasStats) {
      if (copy._hasStats) {
        copy._stats = copy.stats.merge(other.stats);
      } else {
        copy._stats = other._stats;
      }
      copy._hasStats = true;
    }
    if (other._hasDistanceCheckMode) {
      copy._hasDistanceCheckMode = true;
      copy._distanceCheckMode = other._distanceCheckMode;
    }
    if (other._hasDistanceExtendMode) {
      copy._hasDistanceExtendMode = true;
      copy._distanceExtendMode = other._distanceExtendMode;
    }
    if (other._hasTargetFilter) {
      if (copy._hasTargetFilter) {
        copy._targetFilter = copy.targetFilter.merge(other.targetFilter);
      } else {
        copy._targetFilter = other._targetFilter;
      }
      copy._hasTargetFilter = true;
    }
    if (other._hasDisabled) {
      copy._hasDisabled = true;
      copy._disabled = other._disabled;
    }
    return copy;
  }
}
Weapon.default = new Weapon();
class Weapon_Builder {
  constructor(value) {
    this._value = new Weapon(value);
  }
  build() {
    return new Weapon(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._parent = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._parent = null;
    return this;
  }
  setFamily(value) {
    this._value._hasFamily = true;
    this._value._family = value;
    return this;
  }
  deleteFamily() {
    this._value._hasFamily = false;
    this._value._family = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effectName = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effectName = null;
    return this;
  }
  setCriticalChance(value) {
    this._value._hasCriticalChance = true;
    this._value._criticalChance = value;
    return this;
  }
  deleteCriticalChance() {
    this._value._hasCriticalChance = false;
    this._value._criticalChance = null;
    return this;
  }
  setCriticalEffect(value) {
    this._value._hasCriticalEffect = true;
    this._value._criticalEffect = value;
    return this;
  }
  deleteCriticalEffect() {
    this._value._hasCriticalEffect = false;
    this._value._criticalEffect = null;
    return this;
  }
  setIndependentTargetAcquisition(value) {
    this._value._hasIndependentTargetAcquisition = true;
    this._value._independentTargetAcquisition = value;
    return this;
  }
  deleteIndependentTargetAcquisition() {
    this._value._hasIndependentTargetAcquisition = false;
    this._value._independentTargetAcquisition = null;
    return this;
  }
  setIndependentPreAndBackSwing(value) {
    this._value._hasIndependentPreAndBackSwing = true;
    this._value._independentPreAndBackSwing = value;
    return this;
  }
  deleteIndependentPreAndBackSwing() {
    this._value._hasIndependentPreAndBackSwing = false;
    this._value._independentPreAndBackSwing = null;
    return this;
  }
  setCanFireWhileMoving(value) {
    this._value._hasCanFireWhileMoving = true;
    this._value._canFireWhileMoving = value;
    return this;
  }
  deleteCanFireWhileMoving() {
    this._value._hasCanFireWhileMoving = false;
    this._value._canFireWhileMoving = null;
    return this;
  }
  setChanneled(value) {
    this._value._hasChanneled = true;
    this._value._channeled = value;
    return this;
  }
  deleteChanneled() {
    this._value._hasChanneled = false;
    this._value._channeled = null;
    return this;
  }
  setForceCastFollowthrough(value) {
    this._value._hasForceCastFollowthrough = true;
    this._value._forceCastFollowthrough = value;
    return this;
  }
  deleteForceCastFollowthrough() {
    this._value._hasForceCastFollowthrough = false;
    this._value._forceCastFollowthrough = null;
    return this;
  }
  setNoTurnOutsideOfArc(value) {
    this._value._hasNoTurnOutsideOfArc = true;
    this._value._noTurnOutsideOfArc = value;
    return this;
  }
  deleteNoTurnOutsideOfArc() {
    this._value._hasNoTurnOutsideOfArc = false;
    this._value._noTurnOutsideOfArc = null;
    return this;
  }
  addAllValidators(values) {
    this._value._validators = this._value._validators.concat(values);
    return this;
  }
  addValidators(value) {
    this._value._validators = this._value._validators.concat([value]);
    return this;
  }
  setValidators(index, value) {
    this._value._validators = this._value._validators.concat();
    this._value._validators[index] = value;
    return this;
  }
  clearValidators() {
    this._value._validators = [];
    return this;
  }
  setStats(value) {
    this._value._hasStats = true;
    this._value._stats = value;
    return this;
  }
  deleteStats() {
    this._value._hasStats = false;
    this._value._stats = null;
    return this;
  }
  setDistanceCheckMode(value) {
    this._value._hasDistanceCheckMode = true;
    this._value._distanceCheckMode = value;
    return this;
  }
  deleteDistanceCheckMode() {
    this._value._hasDistanceCheckMode = false;
    this._value._distanceCheckMode = null;
    return this;
  }
  setDistanceExtendMode(value) {
    this._value._hasDistanceExtendMode = true;
    this._value._distanceExtendMode = value;
    return this;
  }
  deleteDistanceExtendMode() {
    this._value._hasDistanceExtendMode = false;
    this._value._distanceExtendMode = null;
    return this;
  }
  setTargetFilter(value) {
    this._value._hasTargetFilter = true;
    this._value._targetFilter = value;
    return this;
  }
  deleteTargetFilter() {
    this._value._hasTargetFilter = false;
    this._value._targetFilter = null;
    return this;
  }
  setDisabled(value) {
    this._value._hasDisabled = true;
    this._value._disabled = value;
    return this;
  }
  deleteDisabled() {
    this._value._hasDisabled = false;
    this._value._disabled = null;
    return this;
  }
}
Weapon.Builder = Weapon_Builder;
class Weapon_WithParent {
  /**
   * @param {Weapon} value
   * @param {Weapon_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Weapon.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get parent() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.parent;
      } else {
        this._cachedParent = this._parent ? this._parent.parent : this._value.parent;
      }
    }
    return this._cachedParent;
  }
  get hasFamily() {
    if (this._cachedHasFamily === undefined) {
      if (this._value.hasFamily) {
        this._cachedHasFamily = true;
      } else {
        this._cachedHasFamily = this._parent ? this._parent.hasFamily : false;
      }
    }
    return this._cachedHasFamily;
  }
  get family() {
    if (this._cachedFamily === undefined) {
      if (this._value.hasFamily) {
        this._cachedFamily = this._value.family;
      } else {
        this._cachedFamily = this._parent ? this._parent.family : this._value.family;
      }
    }
    return this._cachedFamily;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effectName() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effectName;
      } else {
        this._cachedEffect = this._parent ? this._parent.effectName : this._value.effectName;
      }
    }
    return this._cachedEffect;
  }
  get hasCriticalChance() {
    if (this._cachedHasCriticalChance === undefined) {
      if (this._value.hasCriticalChance) {
        this._cachedHasCriticalChance = true;
      } else {
        this._cachedHasCriticalChance = this._parent ? this._parent.hasCriticalChance : false;
      }
    }
    return this._cachedHasCriticalChance;
  }
  get criticalChance() {
    if (this._cachedCriticalChance === undefined) {
      if (this._value.hasCriticalChance) {
        this._cachedCriticalChance = this._value.criticalChance;
      } else {
        this._cachedCriticalChance = this._parent ? this._parent.criticalChance : this._value.criticalChance;
      }
    }
    return this._cachedCriticalChance;
  }
  get hasCriticalEffect() {
    if (this._cachedHasCriticalEffect === undefined) {
      if (this._value.hasCriticalEffect) {
        this._cachedHasCriticalEffect = true;
      } else {
        this._cachedHasCriticalEffect = this._parent ? this._parent.hasCriticalEffect : false;
      }
    }
    return this._cachedHasCriticalEffect;
  }
  get criticalEffect() {
    if (this._cachedCriticalEffect === undefined) {
      if (this._value.hasCriticalEffect) {
        this._cachedCriticalEffect = this._value.criticalEffect;
      } else {
        this._cachedCriticalEffect = this._parent ? this._parent.criticalEffect : this._value.criticalEffect;
      }
    }
    return this._cachedCriticalEffect;
  }
  get hasIndependentTargetAcquisition() {
    if (this._cachedHasIndependentTargetAcquisition === undefined) {
      if (this._value.hasIndependentTargetAcquisition) {
        this._cachedHasIndependentTargetAcquisition = true;
      } else {
        this._cachedHasIndependentTargetAcquisition = this._parent ? this._parent.hasIndependentTargetAcquisition : false;
      }
    }
    return this._cachedHasIndependentTargetAcquisition;
  }
  get independentTargetAcquisition() {
    if (this._cachedIndependentTargetAcquisition === undefined) {
      if (this._value.hasIndependentTargetAcquisition) {
        this._cachedIndependentTargetAcquisition = this._value.independentTargetAcquisition;
      } else {
        this._cachedIndependentTargetAcquisition = this._parent ? this._parent.independentTargetAcquisition : this._value.independentTargetAcquisition;
      }
    }
    return this._cachedIndependentTargetAcquisition;
  }
  get hasIndependentPreAndBackSwing() {
    if (this._cachedHasIndependentPreAndBackSwing === undefined) {
      if (this._value.hasIndependentPreAndBackSwing) {
        this._cachedHasIndependentPreAndBackSwing = true;
      } else {
        this._cachedHasIndependentPreAndBackSwing = this._parent ? this._parent.hasIndependentPreAndBackSwing : false;
      }
    }
    return this._cachedHasIndependentPreAndBackSwing;
  }
  get independentPreAndBackSwing() {
    if (this._cachedIndependentPreAndBackSwing === undefined) {
      if (this._value.hasIndependentPreAndBackSwing) {
        this._cachedIndependentPreAndBackSwing = this._value.independentPreAndBackSwing;
      } else {
        this._cachedIndependentPreAndBackSwing = this._parent ? this._parent.independentPreAndBackSwing : this._value.independentPreAndBackSwing;
      }
    }
    return this._cachedIndependentPreAndBackSwing;
  }
  get hasCanFireWhileMoving() {
    if (this._cachedHasCanFireWhileMoving === undefined) {
      if (this._value.hasCanFireWhileMoving) {
        this._cachedHasCanFireWhileMoving = true;
      } else {
        this._cachedHasCanFireWhileMoving = this._parent ? this._parent.hasCanFireWhileMoving : false;
      }
    }
    return this._cachedHasCanFireWhileMoving;
  }
  get canFireWhileMoving() {
    if (this._cachedCanFireWhileMoving === undefined) {
      if (this._value.hasCanFireWhileMoving) {
        this._cachedCanFireWhileMoving = this._value.canFireWhileMoving;
      } else {
        this._cachedCanFireWhileMoving = this._parent ? this._parent.canFireWhileMoving : this._value.canFireWhileMoving;
      }
    }
    return this._cachedCanFireWhileMoving;
  }
  get hasChanneled() {
    if (this._cachedHasChanneled === undefined) {
      if (this._value.hasChanneled) {
        this._cachedHasChanneled = true;
      } else {
        this._cachedHasChanneled = this._parent ? this._parent.hasChanneled : false;
      }
    }
    return this._cachedHasChanneled;
  }
  get channeled() {
    if (this._cachedChanneled === undefined) {
      if (this._value.hasChanneled) {
        this._cachedChanneled = this._value.channeled;
      } else {
        this._cachedChanneled = this._parent ? this._parent.channeled : this._value.channeled;
      }
    }
    return this._cachedChanneled;
  }
  get hasForceCastFollowthrough() {
    if (this._cachedHasForceCastFollowthrough === undefined) {
      if (this._value.hasForceCastFollowthrough) {
        this._cachedHasForceCastFollowthrough = true;
      } else {
        this._cachedHasForceCastFollowthrough = this._parent ? this._parent.hasForceCastFollowthrough : false;
      }
    }
    return this._cachedHasForceCastFollowthrough;
  }
  get forceCastFollowthrough() {
    if (this._cachedForceCastFollowthrough === undefined) {
      if (this._value.hasForceCastFollowthrough) {
        this._cachedForceCastFollowthrough = this._value.forceCastFollowthrough;
      } else {
        this._cachedForceCastFollowthrough = this._parent ? this._parent.forceCastFollowthrough : this._value.forceCastFollowthrough;
      }
    }
    return this._cachedForceCastFollowthrough;
  }
  get hasNoTurnOutsideOfArc() {
    if (this._cachedHasNoTurnOutsideOfArc === undefined) {
      if (this._value.hasNoTurnOutsideOfArc) {
        this._cachedHasNoTurnOutsideOfArc = true;
      } else {
        this._cachedHasNoTurnOutsideOfArc = this._parent ? this._parent.hasNoTurnOutsideOfArc : false;
      }
    }
    return this._cachedHasNoTurnOutsideOfArc;
  }
  get noTurnOutsideOfArc() {
    if (this._cachedNoTurnOutsideOfArc === undefined) {
      if (this._value.hasNoTurnOutsideOfArc) {
        this._cachedNoTurnOutsideOfArc = this._value.noTurnOutsideOfArc;
      } else {
        this._cachedNoTurnOutsideOfArc = this._parent ? this._parent.noTurnOutsideOfArc : this._value.noTurnOutsideOfArc;
      }
    }
    return this._cachedNoTurnOutsideOfArc;
  }
  get selfValidators() {
    return this._value.validators;
  }
  get inherentValidators() {
    if (!this._inherentValidators) {
      this._inherentValidators = this._parent ? this._parent.validators : [];
    }
    return this._inherentValidators;
  }
  get validators() {
    if (!this._allValidators) {
      this._allValidators = this._parent ? this._parent.validators.concat(this.selfValidators) : this.selfValidators;
    }
    return this._allValidators;
  }
  get hasStats() {
    if (this._cachedHasStats === undefined) {
      if (this._value.hasStats) {
        this._cachedHasStats = true;
      } else {
        this._cachedHasStats = this._parent ? this._parent.hasStats : false;
      }
    }
    return this._cachedHasStats;
  }
  get stats() {
    if (!this._cachedStats) {
      if (this._value.hasStats) {
        this._cachedStats = new WeaponStats.WithParent(this._value.stats, this._parent && this._parent.hasStats ? this._parent.stats : null);
      } else {
        this._cachedStats = this._parent ? new WeaponStats.WithParent(WeaponStats.default, this._parent.stats) : WeaponStats.WithParent.default;
      }
    }
    return this._cachedStats;
  }
  get hasDistanceCheckMode() {
    if (this._cachedHasDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedHasDistanceCheckMode = true;
      } else {
        this._cachedHasDistanceCheckMode = this._parent ? this._parent.hasDistanceCheckMode : false;
      }
    }
    return this._cachedHasDistanceCheckMode;
  }
  get distanceCheckMode() {
    if (this._cachedDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedDistanceCheckMode = this._value.distanceCheckMode;
      } else {
        this._cachedDistanceCheckMode = this._parent ? this._parent.distanceCheckMode : this._value.distanceCheckMode;
      }
    }
    return this._cachedDistanceCheckMode;
  }
  get hasDistanceExtendMode() {
    if (this._cachedHasDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedHasDistanceExtendMode = true;
      } else {
        this._cachedHasDistanceExtendMode = this._parent ? this._parent.hasDistanceExtendMode : false;
      }
    }
    return this._cachedHasDistanceExtendMode;
  }
  get distanceExtendMode() {
    if (this._cachedDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedDistanceExtendMode = this._value.distanceExtendMode;
      } else {
        this._cachedDistanceExtendMode = this._parent ? this._parent.distanceExtendMode : this._value.distanceExtendMode;
      }
    }
    return this._cachedDistanceExtendMode;
  }
  get hasTargetFilter() {
    if (this._cachedHasTargetFilter === undefined) {
      if (this._value.hasTargetFilter) {
        this._cachedHasTargetFilter = true;
      } else {
        this._cachedHasTargetFilter = this._parent ? this._parent.hasTargetFilter : false;
      }
    }
    return this._cachedHasTargetFilter;
  }
  get targetFilter() {
    if (!this._cachedTargetFilter) {
      if (this._value.hasTargetFilter) {
        this._cachedTargetFilter = new dcei_engine_effect_proto.SearchFilter.WithParent(this._value.targetFilter, this._parent && this._parent.hasTargetFilter ? this._parent.targetFilter : null);
      } else {
        this._cachedTargetFilter = this._parent ? new dcei_engine_effect_proto.SearchFilter.WithParent(dcei_engine_effect_proto.SearchFilter.default, this._parent.targetFilter) : dcei_engine_effect_proto.SearchFilter.WithParent.default;
      }
    }
    return this._cachedTargetFilter;
  }
  get hasDisabled() {
    if (this._cachedHasDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedHasDisabled = true;
      } else {
        this._cachedHasDisabled = this._parent ? this._parent.hasDisabled : false;
      }
    }
    return this._cachedHasDisabled;
  }
  get disabled() {
    if (this._cachedDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedDisabled = this._value.disabled;
      } else {
        this._cachedDisabled = this._parent ? this._parent.disabled : this._value.disabled;
      }
    }
    return this._cachedDisabled;
  }
  update(current, parent) {
    const result = new Weapon_WithParent(current, parent);
    if (this._cachedStats && this._value.hasStats && current.hasStats) {
      if (this._value.stats === current.stats && this._parent === parent) {
        result._cachedStats = this._cachedStats;
      } else {
        result._cachedStats = this._cachedStats.update(current.stats, parent && parent.hasStats ? parent.stats : null);
      }
    }
    if (this._cachedTargetFilter && this._value.hasTargetFilter && current.hasTargetFilter) {
      if (this._value.targetFilter === current.targetFilter && this._parent === parent) {
        result._cachedTargetFilter = this._cachedTargetFilter;
      } else {
        result._cachedTargetFilter = this._cachedTargetFilter.update(current.targetFilter, parent && parent.hasTargetFilter ? parent.targetFilter : null);
      }
    }
    return result;
  }
}
Weapon_WithParent.default = new Weapon_WithParent(Weapon.default, null);
Weapon.WithParent = Weapon_WithParent;
class Weapon_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get parent() {
    if (!this._parent) {
      this._parent = {
        name: "parent",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedWeaponNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parent;
  }
  get family() {
    if (!this._family) {
      this._family = {
        name: "family",
        Name: "Family",
        number: 20,
        protoType: 9,
        protoName: "family",
        type: JsonToString,
        options: {
          comments: "Used for enabling/disabling families of weapons via behaviors.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._family;
  }
  get effectName() {
    if (!this._effectName) {
      this._effectName = {
        name: "effectName",
        Name: "Effect",
        number: 2,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The Effect created by the weapon on the target unit.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectName;
  }
  get criticalChance() {
    if (!this._criticalChance) {
      this._criticalChance = {
        name: "criticalChance",
        Name: "CriticalChance",
        number: 3,
        protoType: 1,
        protoName: "critical_chance",
        type: JsonToDouble,
        options: {
          comments: "The chance that the weapon attack is considered a critical. The value is a fraction, so 0 is 0% chance and 1 is 100% chance of critical hit.",
          propertyRange: "0,1",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalChance;
  }
  get criticalEffect() {
    if (!this._criticalEffect) {
      this._criticalEffect = {
        name: "criticalEffect",
        Name: "CriticalEffect",
        number: 4,
        protoType: 9,
        protoName: "critical_effect",
        type: JsonToString,
        options: {
          comments: "The effect that is executed instead of the Effect when the ability is a critical. If this is not set, the default Effect will be used on critical instead.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalEffect;
  }
  get independentTargetAcquisition() {
    if (!this._independentTargetAcquisition) {
      this._independentTargetAcquisition = {
        name: "independentTargetAcquisition",
        Name: "IndependentTargetAcquisition",
        number: 5,
        protoType: 8,
        protoName: "independent_target_acquisition",
        type: JsonToBoolean,
        options: {
          comments: "If this is set, this weapon can acquire its own target and search for a target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._independentTargetAcquisition;
  }
  get independentPreAndBackSwing() {
    if (!this._independentPreAndBackSwing) {
      this._independentPreAndBackSwing = {
        name: "independentPreAndBackSwing",
        Name: "IndependentPreAndBackSwing",
        number: 6,
        protoType: 8,
        protoName: "independent_pre_and_back_swing",
        type: JsonToBoolean,
        options: {
          comments: "If this is checked, this weapon can fire when other weapons are in pre or back swing stage.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._independentPreAndBackSwing;
  }
  get canFireWhileMoving() {
    if (!this._canFireWhileMoving) {
      this._canFireWhileMoving = {
        name: "canFireWhileMoving",
        Name: "CanFireWhileMoving",
        number: 7,
        protoType: 8,
        protoName: "can_fire_while_moving",
        type: JsonToBoolean,
        options: {
          comments: "If this is checked, using this weapon will not stop movement.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._canFireWhileMoving;
  }
  get channeled() {
    if (!this._channeled) {
      this._channeled = {
        name: "channeled",
        Name: "Channeled",
        number: 8,
        protoType: 8,
        protoName: "channeled",
        type: JsonToBoolean,
        options: {
          comments: "If this is checked, this weapon will be a channelling weapon along with a channeling persistent effect",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._channeled;
  }
  get forceCastFollowthrough() {
    if (!this._forceCastFollowthrough) {
      this._forceCastFollowthrough = {
        name: "forceCastFollowthrough",
        Name: "ForceCastFollowthrough",
        number: 9,
        protoType: 8,
        protoName: "force_cast_followthrough",
        type: JsonToBoolean,
        options: {
          comments: "If target dies, this flag will keep the weapon firing to the last valid target position",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forceCastFollowthrough;
  }
  get noTurnOutsideOfArc() {
    if (!this._noTurnOutsideOfArc) {
      this._noTurnOutsideOfArc = {
        name: "noTurnOutsideOfArc",
        Name: "NoTurnOutsideOfArc",
        number: 17,
        protoType: 8,
        protoName: "no_turn_outside_of_arc",
        type: JsonToBoolean,
        options: {
          comments: "If the flag is set and target is out of arc, this weapon cannot be used to attack",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._noTurnOutsideOfArc;
  }
  get validators() {
    if (!this._validators) {
      this._validators = {
        name: "validators",
        Name: "Validators",
        number: 11,
        protoType: 9,
        protoName: "validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Weapon does not execute if any validator fails (does not trigger cost or cooldown)",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validators;
  }
  get stats() {
    if (!this._stats) {
      this._stats = {
        name: "stats",
        Name: "Stats",
        number: 12,
        protoType: 11,
        protoName: "stats",
        type: WeaponStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stats;
  }
  get distanceCheckMode() {
    if (!this._distanceCheckMode) {
      this._distanceCheckMode = {
        name: "distanceCheckMode",
        Name: "DistanceCheckMode",
        number: 13,
        protoType: 14,
        protoName: "distance_check_mode",
        type: dcei_engine_effect_proto.DistanceCheckModes,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceCheckMode;
  }
  get distanceExtendMode() {
    if (!this._distanceExtendMode) {
      this._distanceExtendMode = {
        name: "distanceExtendMode",
        Name: "DistanceExtendMode",
        number: 14,
        protoType: 14,
        protoName: "distance_extend_mode",
        type: dcei_engine_effect_proto.DistanceExtendModes,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceExtendMode;
  }
  get targetFilter() {
    if (!this._targetFilter) {
      this._targetFilter = {
        name: "targetFilter",
        Name: "TargetFilter",
        number: 15,
        protoType: 11,
        protoName: "target_filter",
        type: dcei_engine_effect_proto.SearchFilter,
        options: {
          comments: "Used to determine the valid target types for the weapon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetFilter;
  }
  get disabled() {
    if (!this._disabled) {
      this._disabled = {
        name: "disabled",
        Name: "Disabled",
        number: 16,
        protoType: 8,
        protoName: "disabled",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the weapon is disabled by default. Requires behaviors or other means to be enabled.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabled;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.parent,
        this.family,
        this.effectName,
        this.criticalChance,
        this.criticalEffect,
        this.independentTargetAcquisition,
        this.independentPreAndBackSwing,
        this.canFireWhileMoving,
        this.channeled,
        this.forceCastFollowthrough,
        this.noTurnOutsideOfArc,
        this.validators,
        this.stats,
        this.distanceCheckMode,
        this.distanceExtendMode,
        this.targetFilter,
        this.disabled,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFamily",
        Name: "DummyOneofForFamily",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCriticalChance",
        Name: "DummyOneofForCriticalChance",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCriticalEffect",
        Name: "DummyOneofForCriticalEffect",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndependentTargetAcquisition",
        Name: "DummyOneofForIndependentTargetAcquisition",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndependentPreAndBackSwing",
        Name: "DummyOneofForIndependentPreAndBackSwing",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCanFireWhileMoving",
        Name: "DummyOneofForCanFireWhileMoving",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChanneled",
        Name: "DummyOneofForChanneled",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForceCastFollowthrough",
        Name: "DummyOneofForForceCastFollowthrough",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNoTurnOutsideOfArc",
        Name: "DummyOneofForNoTurnOutsideOfArc",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStats",
        Name: "DummyOneofForStats",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceCheckMode",
        Name: "DummyOneofForDistanceCheckMode",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceExtendMode",
        Name: "DummyOneofForDistanceExtendMode",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetFilter",
        Name: "DummyOneofForTargetFilter",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisabled",
        Name: "DummyOneofForDisabled",
        fields: [
          this.fields[19],
        ],
      });
    }
    return this._oneofs;
  }
}
Weapon.descriptor = new Weapon_Descriptor();
export class WeaponStats {
  get descriptor() {
    return WeaponStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedDamagePoint = false;
    this._damagePoint = null;
    this._hasPreSwing = false;
    this._preSwing = null;
    this._hasRandomPreswingDelayMin = false;
    this._randomPreswingDelayMin = null;
    this._hasRandomPreswingDelayMax = false;
    this._randomPreswingDelayMax = null;
    this._hasBackSwing = false;
    this._backSwing = null;
    this._hasPeriod = false;
    this._period = null;
    this._hasUseInitialCooldown = false;
    this._useInitialCooldown = null;
    this._hasUseCooldownOnEnable = false;
    this._useCooldownOnEnable = null;
    this._hasMinimalRange = false;
    this._minimalRange = null;
    this._hasRange = false;
    this._range = null;
    this._hasScanRange = false;
    this._scanRange = null;
    this._hasArc = false;
    this._arc = null;
    this._hasBufferRange = false;
    this._bufferRange = null;
  }
  isEmpty() {
    if (this._hasDeprecatedDamagePoint) return false;
    if (this._hasPreSwing) return false;
    if (this._hasRandomPreswingDelayMin) return false;
    if (this._hasRandomPreswingDelayMax) return false;
    if (this._hasBackSwing) return false;
    if (this._hasPeriod) return false;
    if (this._hasUseInitialCooldown) return false;
    if (this._hasUseCooldownOnEnable) return false;
    if (this._hasMinimalRange) return false;
    if (this._hasRange) return false;
    if (this._hasScanRange) return false;
    if (this._hasArc) return false;
    if (this._hasBufferRange) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof WeaponStats) {
      return value;
    }
    return WeaponStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new WeaponStats();
    if (json.damagePoint != null) {
      result._hasDeprecatedDamagePoint = true;
      result._damagePoint = JsonToDouble.fromJson(json.damagePoint);
    }
    if (json.preSwing != null) {
      result._hasPreSwing = true;
      result._preSwing = JsonToDouble.fromJson(json.preSwing);
    }
    if (json.randomPreswingDelayMin != null) {
      result._hasRandomPreswingDelayMin = true;
      result._randomPreswingDelayMin = JsonToDouble.fromJson(json.randomPreswingDelayMin);
    }
    if (json.randomPreswingDelayMax != null) {
      result._hasRandomPreswingDelayMax = true;
      result._randomPreswingDelayMax = JsonToDouble.fromJson(json.randomPreswingDelayMax);
    }
    if (json.backSwing != null) {
      result._hasBackSwing = true;
      result._backSwing = JsonToDouble.fromJson(json.backSwing);
    }
    if (json.period != null) {
      result._hasPeriod = true;
      result._period = JsonToDouble.fromJson(json.period);
    }
    if (json.useInitialCooldown != null) {
      result._hasUseInitialCooldown = true;
      result._useInitialCooldown = JsonToBoolean.fromJson(json.useInitialCooldown);
    }
    if (json.useCooldownOnEnable != null) {
      result._hasUseCooldownOnEnable = true;
      result._useCooldownOnEnable = JsonToBoolean.fromJson(json.useCooldownOnEnable);
    }
    if (json.minimalRange != null) {
      result._hasMinimalRange = true;
      result._minimalRange = JsonToDouble.fromJson(json.minimalRange);
    }
    if (json.range != null) {
      result._hasRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.scanRange != null) {
      result._hasScanRange = true;
      result._scanRange = JsonToDouble.fromJson(json.scanRange);
    }
    if (json.arc != null) {
      result._hasArc = true;
      result._arc = JsonToDouble.fromJson(json.arc);
    }
    if (json.bufferRange != null) {
      result._hasBufferRange = true;
      result._bufferRange = JsonToDouble.fromJson(json.bufferRange);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedDamagePoint) {
      result.damagePoint = JsonToDouble.toJson(this._damagePoint);
    }
    if (this._hasPreSwing) {
      result.preSwing = JsonToDouble.toJson(this._preSwing);
    }
    if (this._hasRandomPreswingDelayMin) {
      result.randomPreswingDelayMin = JsonToDouble.toJson(this._randomPreswingDelayMin);
    }
    if (this._hasRandomPreswingDelayMax) {
      result.randomPreswingDelayMax = JsonToDouble.toJson(this._randomPreswingDelayMax);
    }
    if (this._hasBackSwing) {
      result.backSwing = JsonToDouble.toJson(this._backSwing);
    }
    if (this._hasPeriod) {
      result.period = JsonToDouble.toJson(this._period);
    }
    if (this._hasUseInitialCooldown) {
      result.useInitialCooldown = JsonToBoolean.toJson(this._useInitialCooldown);
    }
    if (this._hasUseCooldownOnEnable) {
      result.useCooldownOnEnable = JsonToBoolean.toJson(this._useCooldownOnEnable);
    }
    if (this._hasMinimalRange) {
      result.minimalRange = JsonToDouble.toJson(this._minimalRange);
    }
    if (this._hasRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasScanRange) {
      result.scanRange = JsonToDouble.toJson(this._scanRange);
    }
    if (this._hasArc) {
      result.arc = JsonToDouble.toJson(this._arc);
    }
    if (this._hasBufferRange) {
      result.bufferRange = JsonToDouble.toJson(this._bufferRange);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get damagePoint() {
    return this._hasDeprecatedDamagePoint ? this._damagePoint : JsonToDouble.default;
  }
  get hasDeprecatedDamagePoint() {
    return this._hasDeprecatedDamagePoint;
  }
  setDeprecatedDamagePoint(path, value) {
    return {type: 'SET', path: path.concat(['damagePoint']), value};
  }
  deleteDeprecatedDamagePoint(path) {
    return {type: 'DELETE', path: path.concat(['damagePoint'])};
  }
  /**
   * @returns {number}
   */
  get preSwing() {
    return this._hasPreSwing ? this._preSwing : JsonToDouble.default;
  }
  get hasPreSwing() {
    return this._hasPreSwing;
  }
  setPreSwing(path, value) {
    return {type: 'SET', path: path.concat(['preSwing']), value};
  }
  deletePreSwing(path) {
    return {type: 'DELETE', path: path.concat(['preSwing'])};
  }
  /**
   * @returns {number}
   */
  get randomPreswingDelayMin() {
    return this._hasRandomPreswingDelayMin ? this._randomPreswingDelayMin : JsonToDouble.default;
  }
  get hasRandomPreswingDelayMin() {
    return this._hasRandomPreswingDelayMin;
  }
  setRandomPreswingDelayMin(path, value) {
    return {type: 'SET', path: path.concat(['randomPreswingDelayMin']), value};
  }
  deleteRandomPreswingDelayMin(path) {
    return {type: 'DELETE', path: path.concat(['randomPreswingDelayMin'])};
  }
  /**
   * @returns {number}
   */
  get randomPreswingDelayMax() {
    return this._hasRandomPreswingDelayMax ? this._randomPreswingDelayMax : JsonToDouble.default;
  }
  get hasRandomPreswingDelayMax() {
    return this._hasRandomPreswingDelayMax;
  }
  setRandomPreswingDelayMax(path, value) {
    return {type: 'SET', path: path.concat(['randomPreswingDelayMax']), value};
  }
  deleteRandomPreswingDelayMax(path) {
    return {type: 'DELETE', path: path.concat(['randomPreswingDelayMax'])};
  }
  /**
   * @returns {number}
   */
  get backSwing() {
    return this._hasBackSwing ? this._backSwing : JsonToDouble.default;
  }
  get hasBackSwing() {
    return this._hasBackSwing;
  }
  setBackSwing(path, value) {
    return {type: 'SET', path: path.concat(['backSwing']), value};
  }
  deleteBackSwing(path) {
    return {type: 'DELETE', path: path.concat(['backSwing'])};
  }
  /**
   * @returns {number}
   */
  get period() {
    return this._hasPeriod ? this._period : JsonToDouble.default;
  }
  get hasPeriod() {
    return this._hasPeriod;
  }
  setPeriod(path, value) {
    return {type: 'SET', path: path.concat(['period']), value};
  }
  deletePeriod(path) {
    return {type: 'DELETE', path: path.concat(['period'])};
  }
  /**
   * @returns {boolean}
   */
  get useInitialCooldown() {
    return this._hasUseInitialCooldown ? this._useInitialCooldown : JsonToBoolean.default;
  }
  get hasUseInitialCooldown() {
    return this._hasUseInitialCooldown;
  }
  setUseInitialCooldown(path, value) {
    return {type: 'SET', path: path.concat(['useInitialCooldown']), value};
  }
  deleteUseInitialCooldown(path) {
    return {type: 'DELETE', path: path.concat(['useInitialCooldown'])};
  }
  /**
   * @returns {boolean}
   */
  get useCooldownOnEnable() {
    return this._hasUseCooldownOnEnable ? this._useCooldownOnEnable : JsonToBoolean.default;
  }
  get hasUseCooldownOnEnable() {
    return this._hasUseCooldownOnEnable;
  }
  setUseCooldownOnEnable(path, value) {
    return {type: 'SET', path: path.concat(['useCooldownOnEnable']), value};
  }
  deleteUseCooldownOnEnable(path) {
    return {type: 'DELETE', path: path.concat(['useCooldownOnEnable'])};
  }
  /**
   * @returns {number}
   */
  get minimalRange() {
    return this._hasMinimalRange ? this._minimalRange : JsonToDouble.default;
  }
  get hasMinimalRange() {
    return this._hasMinimalRange;
  }
  setMinimalRange(path, value) {
    return {type: 'SET', path: path.concat(['minimalRange']), value};
  }
  deleteMinimalRange(path) {
    return {type: 'DELETE', path: path.concat(['minimalRange'])};
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasRange ? this._range : JsonToDouble.default;
  }
  get hasRange() {
    return this._hasRange;
  }
  setRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {number}
   */
  get scanRange() {
    return this._hasScanRange ? this._scanRange : JsonToDouble.default;
  }
  get hasScanRange() {
    return this._hasScanRange;
  }
  setScanRange(path, value) {
    return {type: 'SET', path: path.concat(['scanRange']), value};
  }
  deleteScanRange(path) {
    return {type: 'DELETE', path: path.concat(['scanRange'])};
  }
  /**
   * @returns {number}
   */
  get arc() {
    return this._hasArc ? this._arc : JsonToDouble.default;
  }
  get hasArc() {
    return this._hasArc;
  }
  setArc(path, value) {
    return {type: 'SET', path: path.concat(['arc']), value};
  }
  deleteArc(path) {
    return {type: 'DELETE', path: path.concat(['arc'])};
  }
  /**
   * @returns {number}
   */
  get bufferRange() {
    return this._hasBufferRange ? this._bufferRange : JsonToDouble.default;
  }
  get hasBufferRange() {
    return this._hasBufferRange;
  }
  setBufferRange(path, value) {
    return {type: 'SET', path: path.concat(['bufferRange']), value};
  }
  deleteBufferRange(path) {
    return {type: 'DELETE', path: path.concat(['bufferRange'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "damagePoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasDeprecatedDamagePoint = true;
              copy._damagePoint = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedDamagePoint) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasDeprecatedDamagePoint = false;
              copy._damagePoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "preSwing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasPreSwing = true;
              copy._preSwing = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreSwing) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasPreSwing = false;
              copy._preSwing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomPreswingDelayMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasRandomPreswingDelayMin = true;
              copy._randomPreswingDelayMin = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomPreswingDelayMin) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasRandomPreswingDelayMin = false;
              copy._randomPreswingDelayMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomPreswingDelayMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasRandomPreswingDelayMax = true;
              copy._randomPreswingDelayMax = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomPreswingDelayMax) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasRandomPreswingDelayMax = false;
              copy._randomPreswingDelayMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "backSwing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasBackSwing = true;
              copy._backSwing = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBackSwing) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasBackSwing = false;
              copy._backSwing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "period": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasPeriod = true;
              copy._period = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriod) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasPeriod = false;
              copy._period = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useInitialCooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasUseInitialCooldown = true;
              copy._useInitialCooldown = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseInitialCooldown) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasUseInitialCooldown = false;
              copy._useInitialCooldown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useCooldownOnEnable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasUseCooldownOnEnable = true;
              copy._useCooldownOnEnable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseCooldownOnEnable) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasUseCooldownOnEnable = false;
              copy._useCooldownOnEnable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "minimalRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasMinimalRange = true;
              copy._minimalRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMinimalRange) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasMinimalRange = false;
              copy._minimalRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRange) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scanRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasScanRange = true;
              copy._scanRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScanRange) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasScanRange = false;
              copy._scanRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "arc": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasArc = true;
              copy._arc = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArc) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasArc = false;
              copy._arc = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bufferRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeaponStats(this);
              copy._hasBufferRange = true;
              copy._bufferRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBufferRange) {
                return this;
              }
              const copy = new WeaponStats(this);
              copy._hasBufferRange = false;
              copy._bufferRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {WeaponStats} other
   * @returns {WeaponStats}
   */
  merge(other) {
    const copy = new WeaponStats(this);
    if (other._hasDeprecatedDamagePoint) {
      copy._hasDeprecatedDamagePoint = true;
      copy._damagePoint = other._damagePoint;
    }
    if (other._hasPreSwing) {
      copy._hasPreSwing = true;
      copy._preSwing = other._preSwing;
    }
    if (other._hasRandomPreswingDelayMin) {
      copy._hasRandomPreswingDelayMin = true;
      copy._randomPreswingDelayMin = other._randomPreswingDelayMin;
    }
    if (other._hasRandomPreswingDelayMax) {
      copy._hasRandomPreswingDelayMax = true;
      copy._randomPreswingDelayMax = other._randomPreswingDelayMax;
    }
    if (other._hasBackSwing) {
      copy._hasBackSwing = true;
      copy._backSwing = other._backSwing;
    }
    if (other._hasPeriod) {
      copy._hasPeriod = true;
      copy._period = other._period;
    }
    if (other._hasUseInitialCooldown) {
      copy._hasUseInitialCooldown = true;
      copy._useInitialCooldown = other._useInitialCooldown;
    }
    if (other._hasUseCooldownOnEnable) {
      copy._hasUseCooldownOnEnable = true;
      copy._useCooldownOnEnable = other._useCooldownOnEnable;
    }
    if (other._hasMinimalRange) {
      copy._hasMinimalRange = true;
      copy._minimalRange = other._minimalRange;
    }
    if (other._hasRange) {
      copy._hasRange = true;
      copy._range = other._range;
    }
    if (other._hasScanRange) {
      copy._hasScanRange = true;
      copy._scanRange = other._scanRange;
    }
    if (other._hasArc) {
      copy._hasArc = true;
      copy._arc = other._arc;
    }
    if (other._hasBufferRange) {
      copy._hasBufferRange = true;
      copy._bufferRange = other._bufferRange;
    }
    return copy;
  }
}
WeaponStats.default = new WeaponStats();
class WeaponStats_Builder {
  constructor(value) {
    this._value = new WeaponStats(value);
  }
  build() {
    return new WeaponStats(this._value);
  }
  setDeprecatedDamagePoint(value) {
    this._value._hasDeprecatedDamagePoint = true;
    this._value._damagePoint = value;
    return this;
  }
  deleteDeprecatedDamagePoint() {
    this._value._hasDeprecatedDamagePoint = false;
    this._value._damagePoint = null;
    return this;
  }
  setPreSwing(value) {
    this._value._hasPreSwing = true;
    this._value._preSwing = value;
    return this;
  }
  deletePreSwing() {
    this._value._hasPreSwing = false;
    this._value._preSwing = null;
    return this;
  }
  setRandomPreswingDelayMin(value) {
    this._value._hasRandomPreswingDelayMin = true;
    this._value._randomPreswingDelayMin = value;
    return this;
  }
  deleteRandomPreswingDelayMin() {
    this._value._hasRandomPreswingDelayMin = false;
    this._value._randomPreswingDelayMin = null;
    return this;
  }
  setRandomPreswingDelayMax(value) {
    this._value._hasRandomPreswingDelayMax = true;
    this._value._randomPreswingDelayMax = value;
    return this;
  }
  deleteRandomPreswingDelayMax() {
    this._value._hasRandomPreswingDelayMax = false;
    this._value._randomPreswingDelayMax = null;
    return this;
  }
  setBackSwing(value) {
    this._value._hasBackSwing = true;
    this._value._backSwing = value;
    return this;
  }
  deleteBackSwing() {
    this._value._hasBackSwing = false;
    this._value._backSwing = null;
    return this;
  }
  setPeriod(value) {
    this._value._hasPeriod = true;
    this._value._period = value;
    return this;
  }
  deletePeriod() {
    this._value._hasPeriod = false;
    this._value._period = null;
    return this;
  }
  setUseInitialCooldown(value) {
    this._value._hasUseInitialCooldown = true;
    this._value._useInitialCooldown = value;
    return this;
  }
  deleteUseInitialCooldown() {
    this._value._hasUseInitialCooldown = false;
    this._value._useInitialCooldown = null;
    return this;
  }
  setUseCooldownOnEnable(value) {
    this._value._hasUseCooldownOnEnable = true;
    this._value._useCooldownOnEnable = value;
    return this;
  }
  deleteUseCooldownOnEnable() {
    this._value._hasUseCooldownOnEnable = false;
    this._value._useCooldownOnEnable = null;
    return this;
  }
  setMinimalRange(value) {
    this._value._hasMinimalRange = true;
    this._value._minimalRange = value;
    return this;
  }
  deleteMinimalRange() {
    this._value._hasMinimalRange = false;
    this._value._minimalRange = null;
    return this;
  }
  setRange(value) {
    this._value._hasRange = true;
    this._value._range = value;
    return this;
  }
  deleteRange() {
    this._value._hasRange = false;
    this._value._range = null;
    return this;
  }
  setScanRange(value) {
    this._value._hasScanRange = true;
    this._value._scanRange = value;
    return this;
  }
  deleteScanRange() {
    this._value._hasScanRange = false;
    this._value._scanRange = null;
    return this;
  }
  setArc(value) {
    this._value._hasArc = true;
    this._value._arc = value;
    return this;
  }
  deleteArc() {
    this._value._hasArc = false;
    this._value._arc = null;
    return this;
  }
  setBufferRange(value) {
    this._value._hasBufferRange = true;
    this._value._bufferRange = value;
    return this;
  }
  deleteBufferRange() {
    this._value._hasBufferRange = false;
    this._value._bufferRange = null;
    return this;
  }
}
WeaponStats.Builder = WeaponStats_Builder;
class WeaponStats_WithParent {
  /**
   * @param {WeaponStats} value
   * @param {WeaponStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return WeaponStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedDamagePoint() {
    if (this._cachedHasDeprecatedDamagePoint === undefined) {
      if (this._value.hasDeprecatedDamagePoint) {
        this._cachedHasDeprecatedDamagePoint = true;
      } else {
        this._cachedHasDeprecatedDamagePoint = this._parent ? this._parent.hasDeprecatedDamagePoint : false;
      }
    }
    return this._cachedHasDeprecatedDamagePoint;
  }
  get damagePoint() {
    if (this._cachedDeprecatedDamagePoint === undefined) {
      if (this._value.hasDeprecatedDamagePoint) {
        this._cachedDeprecatedDamagePoint = this._value.damagePoint;
      } else {
        this._cachedDeprecatedDamagePoint = this._parent ? this._parent.damagePoint : this._value.damagePoint;
      }
    }
    return this._cachedDeprecatedDamagePoint;
  }
  get hasPreSwing() {
    if (this._cachedHasPreSwing === undefined) {
      if (this._value.hasPreSwing) {
        this._cachedHasPreSwing = true;
      } else {
        this._cachedHasPreSwing = this._parent ? this._parent.hasPreSwing : false;
      }
    }
    return this._cachedHasPreSwing;
  }
  get preSwing() {
    if (this._cachedPreSwing === undefined) {
      if (this._value.hasPreSwing) {
        this._cachedPreSwing = this._value.preSwing;
      } else {
        this._cachedPreSwing = this._parent ? this._parent.preSwing : this._value.preSwing;
      }
    }
    return this._cachedPreSwing;
  }
  get hasRandomPreswingDelayMin() {
    if (this._cachedHasRandomPreswingDelayMin === undefined) {
      if (this._value.hasRandomPreswingDelayMin) {
        this._cachedHasRandomPreswingDelayMin = true;
      } else {
        this._cachedHasRandomPreswingDelayMin = this._parent ? this._parent.hasRandomPreswingDelayMin : false;
      }
    }
    return this._cachedHasRandomPreswingDelayMin;
  }
  get randomPreswingDelayMin() {
    if (this._cachedRandomPreswingDelayMin === undefined) {
      if (this._value.hasRandomPreswingDelayMin) {
        this._cachedRandomPreswingDelayMin = this._value.randomPreswingDelayMin;
      } else {
        this._cachedRandomPreswingDelayMin = this._parent ? this._parent.randomPreswingDelayMin : this._value.randomPreswingDelayMin;
      }
    }
    return this._cachedRandomPreswingDelayMin;
  }
  get hasRandomPreswingDelayMax() {
    if (this._cachedHasRandomPreswingDelayMax === undefined) {
      if (this._value.hasRandomPreswingDelayMax) {
        this._cachedHasRandomPreswingDelayMax = true;
      } else {
        this._cachedHasRandomPreswingDelayMax = this._parent ? this._parent.hasRandomPreswingDelayMax : false;
      }
    }
    return this._cachedHasRandomPreswingDelayMax;
  }
  get randomPreswingDelayMax() {
    if (this._cachedRandomPreswingDelayMax === undefined) {
      if (this._value.hasRandomPreswingDelayMax) {
        this._cachedRandomPreswingDelayMax = this._value.randomPreswingDelayMax;
      } else {
        this._cachedRandomPreswingDelayMax = this._parent ? this._parent.randomPreswingDelayMax : this._value.randomPreswingDelayMax;
      }
    }
    return this._cachedRandomPreswingDelayMax;
  }
  get hasBackSwing() {
    if (this._cachedHasBackSwing === undefined) {
      if (this._value.hasBackSwing) {
        this._cachedHasBackSwing = true;
      } else {
        this._cachedHasBackSwing = this._parent ? this._parent.hasBackSwing : false;
      }
    }
    return this._cachedHasBackSwing;
  }
  get backSwing() {
    if (this._cachedBackSwing === undefined) {
      if (this._value.hasBackSwing) {
        this._cachedBackSwing = this._value.backSwing;
      } else {
        this._cachedBackSwing = this._parent ? this._parent.backSwing : this._value.backSwing;
      }
    }
    return this._cachedBackSwing;
  }
  get hasPeriod() {
    if (this._cachedHasPeriod === undefined) {
      if (this._value.hasPeriod) {
        this._cachedHasPeriod = true;
      } else {
        this._cachedHasPeriod = this._parent ? this._parent.hasPeriod : false;
      }
    }
    return this._cachedHasPeriod;
  }
  get period() {
    if (this._cachedPeriod === undefined) {
      if (this._value.hasPeriod) {
        this._cachedPeriod = this._value.period;
      } else {
        this._cachedPeriod = this._parent ? this._parent.period : this._value.period;
      }
    }
    return this._cachedPeriod;
  }
  get hasUseInitialCooldown() {
    if (this._cachedHasUseInitialCooldown === undefined) {
      if (this._value.hasUseInitialCooldown) {
        this._cachedHasUseInitialCooldown = true;
      } else {
        this._cachedHasUseInitialCooldown = this._parent ? this._parent.hasUseInitialCooldown : false;
      }
    }
    return this._cachedHasUseInitialCooldown;
  }
  get useInitialCooldown() {
    if (this._cachedUseInitialCooldown === undefined) {
      if (this._value.hasUseInitialCooldown) {
        this._cachedUseInitialCooldown = this._value.useInitialCooldown;
      } else {
        this._cachedUseInitialCooldown = this._parent ? this._parent.useInitialCooldown : this._value.useInitialCooldown;
      }
    }
    return this._cachedUseInitialCooldown;
  }
  get hasUseCooldownOnEnable() {
    if (this._cachedHasUseCooldownOnEnable === undefined) {
      if (this._value.hasUseCooldownOnEnable) {
        this._cachedHasUseCooldownOnEnable = true;
      } else {
        this._cachedHasUseCooldownOnEnable = this._parent ? this._parent.hasUseCooldownOnEnable : false;
      }
    }
    return this._cachedHasUseCooldownOnEnable;
  }
  get useCooldownOnEnable() {
    if (this._cachedUseCooldownOnEnable === undefined) {
      if (this._value.hasUseCooldownOnEnable) {
        this._cachedUseCooldownOnEnable = this._value.useCooldownOnEnable;
      } else {
        this._cachedUseCooldownOnEnable = this._parent ? this._parent.useCooldownOnEnable : this._value.useCooldownOnEnable;
      }
    }
    return this._cachedUseCooldownOnEnable;
  }
  get hasMinimalRange() {
    if (this._cachedHasMinimalRange === undefined) {
      if (this._value.hasMinimalRange) {
        this._cachedHasMinimalRange = true;
      } else {
        this._cachedHasMinimalRange = this._parent ? this._parent.hasMinimalRange : false;
      }
    }
    return this._cachedHasMinimalRange;
  }
  get minimalRange() {
    if (this._cachedMinimalRange === undefined) {
      if (this._value.hasMinimalRange) {
        this._cachedMinimalRange = this._value.minimalRange;
      } else {
        this._cachedMinimalRange = this._parent ? this._parent.minimalRange : this._value.minimalRange;
      }
    }
    return this._cachedMinimalRange;
  }
  get hasRange() {
    if (this._cachedHasRange === undefined) {
      if (this._value.hasRange) {
        this._cachedHasRange = true;
      } else {
        this._cachedHasRange = this._parent ? this._parent.hasRange : false;
      }
    }
    return this._cachedHasRange;
  }
  get range() {
    if (this._cachedRange === undefined) {
      if (this._value.hasRange) {
        this._cachedRange = this._value.range;
      } else {
        this._cachedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedRange;
  }
  get hasScanRange() {
    if (this._cachedHasScanRange === undefined) {
      if (this._value.hasScanRange) {
        this._cachedHasScanRange = true;
      } else {
        this._cachedHasScanRange = this._parent ? this._parent.hasScanRange : false;
      }
    }
    return this._cachedHasScanRange;
  }
  get scanRange() {
    if (this._cachedScanRange === undefined) {
      if (this._value.hasScanRange) {
        this._cachedScanRange = this._value.scanRange;
      } else {
        this._cachedScanRange = this._parent ? this._parent.scanRange : this._value.scanRange;
      }
    }
    return this._cachedScanRange;
  }
  get hasArc() {
    if (this._cachedHasArc === undefined) {
      if (this._value.hasArc) {
        this._cachedHasArc = true;
      } else {
        this._cachedHasArc = this._parent ? this._parent.hasArc : false;
      }
    }
    return this._cachedHasArc;
  }
  get arc() {
    if (this._cachedArc === undefined) {
      if (this._value.hasArc) {
        this._cachedArc = this._value.arc;
      } else {
        this._cachedArc = this._parent ? this._parent.arc : this._value.arc;
      }
    }
    return this._cachedArc;
  }
  get hasBufferRange() {
    if (this._cachedHasBufferRange === undefined) {
      if (this._value.hasBufferRange) {
        this._cachedHasBufferRange = true;
      } else {
        this._cachedHasBufferRange = this._parent ? this._parent.hasBufferRange : false;
      }
    }
    return this._cachedHasBufferRange;
  }
  get bufferRange() {
    if (this._cachedBufferRange === undefined) {
      if (this._value.hasBufferRange) {
        this._cachedBufferRange = this._value.bufferRange;
      } else {
        this._cachedBufferRange = this._parent ? this._parent.bufferRange : this._value.bufferRange;
      }
    }
    return this._cachedBufferRange;
  }
  update(current, parent) {
    const result = new WeaponStats_WithParent(current, parent);
    return result;
  }
}
WeaponStats_WithParent.default = new WeaponStats_WithParent(WeaponStats.default, null);
WeaponStats.WithParent = WeaponStats_WithParent;
class WeaponStats_Descriptor {
  get damagePoint() {
    if (!this._damagePoint) {
      this._damagePoint = {
        name: "damagePoint",
        Name: "DeprecatedDamagePoint",
        number: 1001,
        protoType: 1,
        protoName: "deprecated_damage_point",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damagePoint;
  }
  get preSwing() {
    if (!this._preSwing) {
      this._preSwing = {
        name: "preSwing",
        Name: "PreSwing",
        number: 1,
        protoType: 1,
        protoName: "pre_swing",
        type: JsonToDouble,
        options: {
          comments: "The delay between the weapon starting to fire and the effect being executed.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preSwing;
  }
  get randomPreswingDelayMin() {
    if (!this._randomPreswingDelayMin) {
      this._randomPreswingDelayMin = {
        name: "randomPreswingDelayMin",
        Name: "RandomPreswingDelayMin",
        number: 8,
        protoType: 1,
        protoName: "random_preswing_delay_min",
        type: JsonToDouble,
        options: {
          comments: "The minimum random delay added to the weapon\'s Pre Swing stats. Supports negative numbers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomPreswingDelayMin;
  }
  get randomPreswingDelayMax() {
    if (!this._randomPreswingDelayMax) {
      this._randomPreswingDelayMax = {
        name: "randomPreswingDelayMax",
        Name: "RandomPreswingDelayMax",
        number: 9,
        protoType: 1,
        protoName: "random_preswing_delay_max",
        type: JsonToDouble,
        options: {
          comments: "The maximum random delay added to the weapon\'s Pre Swing stats. Supports negative numbers.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomPreswingDelayMax;
  }
  get backSwing() {
    if (!this._backSwing) {
      this._backSwing = {
        name: "backSwing",
        Name: "BackSwing",
        number: 2,
        protoType: 1,
        protoName: "back_swing",
        type: JsonToDouble,
        options: {
          comments: "The delay between the effect being executed and the weapon firing state ending.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._backSwing;
  }
  get period() {
    if (!this._period) {
      this._period = {
        name: "period",
        Name: "Period",
        number: 3,
        protoType: 1,
        protoName: "period",
        type: JsonToDouble,
        options: {
          comments: "The cooldown of the weapon or how long the unit must wait to use it again.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._period;
  }
  get useInitialCooldown() {
    if (!this._useInitialCooldown) {
      this._useInitialCooldown = {
        name: "useInitialCooldown",
        Name: "UseInitialCooldown",
        number: 11,
        protoType: 8,
        protoName: "use_initial_cooldown",
        type: JsonToBoolean,
        options: {
          comments: "If checked, this weapon will start on cooldown.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useInitialCooldown;
  }
  get useCooldownOnEnable() {
    if (!this._useCooldownOnEnable) {
      this._useCooldownOnEnable = {
        name: "useCooldownOnEnable",
        Name: "UseCooldownOnEnable",
        number: 12,
        protoType: 8,
        protoName: "use_cooldown_on_enable",
        type: JsonToBoolean,
        options: {
          comments: "If checked, this weapon will enter cooldown when it is disabled then enabled.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useCooldownOnEnable;
  }
  get minimalRange() {
    if (!this._minimalRange) {
      this._minimalRange = {
        name: "minimalRange",
        Name: "MinimalRange",
        number: 4,
        protoType: 1,
        protoName: "minimal_range",
        type: JsonToDouble,
        options: {
          comments: "The minimum distance the weapon can fire at.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._minimalRange;
  }
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "Range",
        number: 5,
        protoType: 1,
        protoName: "range",
        type: JsonToDouble,
        options: {
          comments: "The maximum distance the weapon can fire at.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get scanRange() {
    if (!this._scanRange) {
      this._scanRange = {
        name: "scanRange",
        Name: "ScanRange",
        number: 6,
        protoType: 1,
        protoName: "scan_range",
        type: JsonToDouble,
        options: {
          comments: "The range that the unit will use to search for targets to acquire when using this weapon.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scanRange;
  }
  get arc() {
    if (!this._arc) {
      this._arc = {
        name: "arc",
        Name: "Arc",
        number: 7,
        protoType: 1,
        protoName: "arc",
        type: JsonToDouble,
        options: {
          comments: "The angle in front of the caster that targets must be in. If the target is outside this arc, the caster will attempt to turn to face the target before casting.",
          propertyRange: "0, 360",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arc;
  }
  get bufferRange() {
    if (!this._bufferRange) {
      this._bufferRange = {
        name: "bufferRange",
        Name: "BufferRange",
        number: 10,
        protoType: 1,
        protoName: "buffer_range",
        type: JsonToDouble,
        options: {
          comments: "Determines the distance targets must move beyond of the weapon range that will cause the weapon to cancel during pre swing. The default value of 0 causes the buffer range to be infinite.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bufferRange;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.damagePoint,
        this.preSwing,
        this.randomPreswingDelayMin,
        this.randomPreswingDelayMax,
        this.backSwing,
        this.period,
        this.useInitialCooldown,
        this.useCooldownOnEnable,
        this.minimalRange,
        this.range,
        this.scanRange,
        this.arc,
        this.bufferRange,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedDamagePoint",
        Name: "DummyOneofForDeprecatedDamagePoint",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPreSwing",
        Name: "DummyOneofForPreSwing",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomPreswingDelayMin",
        Name: "DummyOneofForRandomPreswingDelayMin",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomPreswingDelayMax",
        Name: "DummyOneofForRandomPreswingDelayMax",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBackSwing",
        Name: "DummyOneofForBackSwing",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriod",
        Name: "DummyOneofForPeriod",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseInitialCooldown",
        Name: "DummyOneofForUseInitialCooldown",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseCooldownOnEnable",
        Name: "DummyOneofForUseCooldownOnEnable",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMinimalRange",
        Name: "DummyOneofForMinimalRange",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRange",
        Name: "DummyOneofForRange",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScanRange",
        Name: "DummyOneofForScanRange",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForArc",
        Name: "DummyOneofForArc",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBufferRange",
        Name: "DummyOneofForBufferRange",
        fields: [
          this.fields[12],
        ],
      });
    }
    return this._oneofs;
  }
}
WeaponStats.descriptor = new WeaponStats_Descriptor();
